import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LeftContent = _resolveComponent("LeftContent");
    const _component_RightContent = _resolveComponent("RightContent");
    const _component_VerticalDividedDialog = _resolveComponent("VerticalDividedDialog");
    return (_openBlock(), _createBlock(_component_VerticalDividedDialog, {
        "is-open": _ctx.isDialogOpen,
        "on-cancel": _ctx.handleClickCancelDialogBtn,
        "on-apply": _ctx.handleClickApplyDialogBtn,
        "dialog-css-class": "width-md ratio-5-5"
    }, {
        title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.locale.title) + " / " + _toDisplayString(_ctx.formattdStoreName), 1 /* TEXT */)
        ]),
        appendTitle: _withCtx(() => _cache[0] || (_cache[0] = [])),
        leftSubTitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.locale.left_sub_title), 1 /* TEXT */)
        ]),
        appendLeftSubTitle: _withCtx(() => _cache[1] || (_cache[1] = [])),
        rightSubTitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.locale.right_sub_title), 1 /* TEXT */)
        ]),
        appendRightSubTitle: _withCtx(() => [
            _createTextVNode(" (" + _toDisplayString(_ctx.finalStoreDongLength) + ") ", 1 /* TEXT */)
        ]),
        leftContent: _withCtx(() => [
            _createVNode(_component_LeftContent, {
                "is-fetching": _ctx.isFetching.getEupMyeonDongList,
                "is-error": _ctx.isError.getEupMyeonDongList
            }, null, 8 /* PROPS */, ["is-fetching", "is-error"])
        ]),
        rightContent: _withCtx(() => [
            _createVNode(_component_RightContent, {
                "is-fetching": _ctx.isFetching.getStoreDeliveryPossibleAreaList,
                "is-error": _ctx.isError.getStoreDeliveryPossibleAreaList
            }, null, 8 /* PROPS */, ["is-fetching", "is-error"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "on-cancel", "on-apply"]));
}
